import { IBaseResponse } from "@carm/_utils/models";

export interface IMetadata {
  id: string;
  keyValues: KeyValue[];
}

export interface KeyValue {
  key: string;
  value: string;
  sortOrder?: number;
  parentKey?: string;
  parentValue?: string;
}

export interface FilterOptions extends KeyValue {
  options?: KeyValue[];
}

export interface IAllMetadataResponse extends IBaseResponse {
  metadata: IMetadataResponse[];
}

export interface IMetadataResponse {
  keyValues: IKeyValuesResponse;
  uid: string;
}

export interface IKeyValuesResponse {
  keyValue: KeyValue[];
}

export enum CadMetadataStatusKeys {
  // ex: https://localhost:9002/carmwebservices/v2/carm/metadata/key/cad_roi_status
  Declaration = 'cad_declaration_status',
  TempImport = 'cad_temporaryImport_status',
  DDB = 'cad_dutydrawback_status',
  ROI = 'cad_roi_status',
  MassAdjustment = 'cad_massadjustment_status'
}
